import { Link } from "@tanstack/react-router"
import { Avatar } from "~/components/ui/avatar"
import { Header } from "~/components/layout/header"

interface Props {
  name?: string
  avatarUrl?: string
  variant: "group" | "user"
  id?: number
  titleLines?: 1 | 3
}

export function PeerHeader({ name, avatarUrl, variant, id, titleLines = 1 }: Props) {
  const href = id ? (variant === "group" ? `/group/${id}` : `/user/${id}`) : undefined

  const content = (
    <>
      <Avatar url={avatarUrl} name={name} variant={variant} className="size-header-icon" />
      <div lang="ru" className={`hyphens-auto text-lg ${titleLines === 3 ? "line-clamp-3" : "truncate"}`}>
        {name ?? "Загрузка..."}
      </div>
    </>
  )

  return (
    <Header>
      {href
        ? <Link to={href} className="flex items-center gap-s min-w-0 flex-1">{content}</Link>
        : content
      }
    </Header>
  )
}
